import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/CrmCustomerReport";

export const RegionEmployees = (options) =>
  GENERATE_URL(`${PREFIX_URL}/RegionEmployees`, options);

export const TagGroups = (options) =>
  GENERATE_URL(`${PREFIX_URL}/TagGroups`, options);

export const ProductBrands = (options) =>
  GENERATE_URL(`${PREFIX_URL}/ProductBrands`, options);

export const LeadPlatforms = (options) =>
  GENERATE_URL(`${PREFIX_URL}/LeadPlatforms`, options);

export const Reactions = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Reactions`, options);

export const ReactionEmployees = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Reactions/Employees`, options);

export default {
  RegionEmployees,
  TagGroups,
  ProductBrands,
  LeadPlatforms,
  Reactions,
  ReactionEmployees,
};
